export default __webpack_public_path__ + "static/media/compact.6d3ba1a1.png";